// extracted by mini-css-extract-plugin
export var askAiIcon = "_o0-j";
export var category = "_o0-9";
export var categoryHeader = "_o0-e";
export var container = "_o0-0";
export var group = "_o0-a";
export var groupItems = "_o0-f";
export var groupSeparator = "_o0-k";
export var loading = "_o0-1";
export var noResults = "_o0-3";
export var placeholder = "_o0-2";
export var resultContent = "_o0-5";
export var resultIcon = "_o0-c";
export var resultItem = "_o0-g";
export var resultMeta = "_o0-8";
export var resultSubtitle = "_o0-7";
export var resultSuffix = "_o0-i";
export var resultTitle = "_o0-6";
export var resultsList = "_o0-4";
export var searchGroup = "_o0-d";
export var selected = "_o0-h";
export var subgroup = "_o0-b";